import React from "react";

import style from "./IntroPage.module.css";

import brain from "../../../assets/icons/cca_logo_blue.svg";

import BoxContainer from "../BoxContainer/BoxContainer";

import view from "../../../assets/icons/home/view.svg";

import upload from "../../../assets/icons/home/upload.svg";

import planList from "../../../assets/icons/home/plan_list.svg";



const IntroPage = () => {

  const boxData = [

    {

      image: planList,

      title: "Structured Reporting",

      mainContent: "Incorporate clients, projects, and titles to be displayed in tabular format within a data list view."

    },

    {

      image: upload,

      title: "Documentation and Insights",

      mainContent: "Upload one or multiple images within each project title to assess contrast issues."

    },

    {

      image: view,

      title: "Issue Tracking",

      mainContent: "Compare multiple instances of the same image containing issues & their details."

    }

  ];

  return (

    <div className={style.mainContainer}>

      <div className={style.headingContainer}>
        <img src={brain} alt="brain" draggable={false}/>
        <h1>Accessibility Bug Reporting</h1>

      </div>

      <div className={style.textContainer}>

        <p className={style.text}>

          This tool serves as a vital resource for identifying, documenting, and addressing accessibility issues within digital platforms.

        </p>

      </div>

    

      <div className={style.boxContainer}>

        {boxData.map((box, index) => (

          <BoxContainer

            key={index}

            index={index}

            image={box.image}

            title={box.title}

            mainContent={box.mainContent}

          />

        ))}

      </div>

    </div>

  );

};



export default IntroPage;

